module.exports = __webpack_public_path__ + "static/img/female-bg-id.4f3da172.png";